import MenuPrimaryItem from './MenuPrimaryItem'

export default MenuPrimaryItem
